import { combineReducers } from 'redux';

import { SET_SOCIAL_PROVIDER, SET_SOCIAL_DATA } from '../actions/social';

const socialProvider = (state = '', { type, payload }) => {
    let nextState = state;

    if (type === SET_SOCIAL_PROVIDER) {
        nextState = payload;
    }

    return nextState;
};

const socialData = (
    state = { apple: {}, facebook: {}, google: {} },
    { type, payload },
) => {
    const nextState = state;

    if (type === SET_SOCIAL_DATA) {
        nextState[payload.socialProvider] = payload.socialData;
    }

    return nextState;
};

export default combineReducers({
    socialProvider,
    socialData,
});
